<template>
  <v-card>
    <v-card-title>
      <div class="layout row ma-0">
        <div class="title">{{title}}</div>
        <v-spacer></v-spacer>
        <div class="caption">
          <v-icon>trending_up</v-icon>
        </div>
      </div>
    </v-card-title>
    <v-card-text class="white--text">
      <e-chart :option="defaultOption" height="400px" :width="width"></e-chart>
    </v-card-text>
  </v-card>
</template>

<script>
import EChart from '@/components/chart/echart'

export default {
  name: 'StackedLineChart',
  components: {
    EChart
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    legend: {
      type: Array,
      default: () => []
    },
    xAxisLabel: {
      type: Array,
      default: () => []
    },
    series: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      width: '99%'
    }
  },
  mounted () {
    this.width = '100%'
  },
  computed: {
    defaultOption () {
      let defaultOption =
      {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: this.legend
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            // dataView : {show: true},
            magicType: { show: true, type: ['line', 'bar'] }
            // restore : {show: true},
            // saveAsImage : {show: true},
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: this.xAxisLabel
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: this.series
        // series: [
        //   {
        //     name: 'Fase 1',
        //     type: 'line',
        //     data: [120, 132, 101, 134, 90, 230, 210]
        //   },
        //   {
        //     name: 'Fase 2',
        //     type: 'line',
        //     data: [220, 182, 191, 234, 290, 330, 310]
        //   },
        //   {
        //     name: 'Fase 3',
        //     type: 'line',
        //     data: [150, 232, 201, 154, 190, 330, 410]
        //   },
        //   {
        //     name: 'Fase 4',
        //     type: 'line',
        //     data: [320, 332, 301, 334, 390, 330, 320]
        //   },

        // ]
      }
      return defaultOption
    }

  }

}
</script>

<style>
</style>
